import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavController } from "@ionic/angular";
import { NotificationsService } from "src/app/api/notifications.service";

@Component({
  selector: "app-notifications-button",
  templateUrl: "./notifications-button.component.html",
  styleUrls: ["./notifications-button.component.scss"],
})
export class NotificationsButtonComponent implements OnInit {
  public nbNotification: any;
  constructor(
    private navCtrl: NavController,
    public notificationsService: NotificationsService
  ) {}
  ngOnInit(): void {
    this.getNumberNotifications();
  }

  getNumberNotifications() {
    let t = this;
    this.notificationsService.CountNotifications().then((response) => {
      t.nbNotification = response["nb_notifications"];
    });
  }

  goToNotifications() {
    this.navCtrl.navigateForward("/tabs/notifications");
  }
}
